import { type ReactNode, StrictMode } from "react";

import { ThemeProvider } from "design-system/components/ThemeProvider";

import { AuthGate } from "../AuthGate";

interface AuthShellProps {
  children: ReactNode;
}

export const AuthShell = ({ children }: AuthShellProps) => (
  <StrictMode>
    <ThemeProvider>
      <AuthGate isEnabled={!import.meta.env.VITE_ACCESS_TOKEN_OVERRIDE}>
        {children}
      </AuthGate>
    </ThemeProvider>
  </StrictMode>
);
